const en = {
  description: `We help some of the world's greatest teams in reaching new heights`,
};
export default en;
